import { JsonLdScript } from "./JsonLdScript";

interface PDPSeoBreadcrumbSchemaProps {
    breadcrumbsData: { label: string; link: string }[];
}
export const PDPSeoBreadcrumbSchema = ({ breadcrumbsData }: PDPSeoBreadcrumbSchemaProps) => {
    const itemListElement = breadcrumbsData.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.label,
        item: `${process.env.NEXT_PUBLIC_BASEPATH}/${item.link}`,
    }));

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: itemListElement,
    };
    return <JsonLdScript data={jsonLd} />;
};
